export default {
  BANK_ACCOUNT_CARD_NUMBER_INVALID: "شماره کارت بانکی نامعتبر است.",
  AMOUNT_IS_LESS_THAN_AT_LEAST_AMOUNT_TRANSACTION:
    "مبلغ وارد شده کمتر از حداقل مبلغ درخواستی است.",
  AMOUNT_IS_MORE_THAN_AMOUNT_USER_CAN_ASK_TRANSACTION:
    "مبلغ وارد شده بیشتر از مبلغ قابل انتقال از موجودی است.",
};
